import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * Wallet page now lives inside the Billing page as a tab.
 * This component redirects to /billing with the wallet tab pre-selected.
 */
export default function WalletPage() {
  const navigate = useNavigate()

  useEffect(() => {
    navigate('/billing?tab=wallet', { replace: true })
  }, [navigate])

  return null
}
